import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  ElementRef,
  inject,
  model,
  signal,
  ViewChild,
  OnInit,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AppBreadcrumb } from '@app/layout/components/app.breadcrumb';
import { ClientConfigService } from '@app/layout/service/client-config/client-config.service';
import { LayoutService } from '@app/layout/service/layout.service';
import { Account } from '@core/models/auth.model';
import { SessionService } from '@core/services/session/session.service';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DatePicker } from 'primeng/datepicker';
import { FloatLabel } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';

@Component({
  selector: '[client-topbar]',
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    StyleClassModule,
    AppBreadcrumb,
    InputTextModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    RippleModule,
    BadgeModule,
    OverlayBadgeModule,
    AvatarModule,
    DatePicker,
    FloatLabel,
  ],
  templateUrl: './client-topbar.component.html',
})
export class ClientTopbarComponent implements OnInit {
  private readonly clientConfigService = inject(ClientConfigService);
  public clientConfig = this.clientConfigService.getConfig()!;
  private readonly layoutService = inject(LayoutService);
  private readonly sessionService = inject(SessionService);
  private readonly router = inject(Router);

  isDarkTheme = computed(() => this.layoutService.isDarkTheme());

  @ViewChild('menubutton') menuButton!: ElementRef;

  rangeDates = signal<Date[]>([]);

  account!: Account;

  ngOnInit(): void {
    this.account = this.sessionService.getActiveSession()!;
  }

  logout() {
    this.sessionService.logout();
  }

  changeAccount() {
    this.router.navigate(['/auth/change-account']);
  }

  notificationsBars = signal<any[]>([
    {
      id: 'inbox',
      label: 'Inbox',
      badge: '2',
    },
    {
      id: 'email',
      label: 'Email',
    },
    {
      id: 'calendar',
      label: 'Calendario',
    },
  ]);

  notifications = signal<any[]>([]);

  selectedNotificationBar = model(this.notificationsBars()[0].id ?? 'inbox');

  selectedNotificationsBarData = computed(
    () => this.notifications().find((f) => f.id === this.selectedNotificationBar()).data,
  );

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  showRightMenu() {
    this.layoutService.toggleRightMenu();
  }

  onConfigButtonClick() {
    this.layoutService.showConfigSidebar();
  }

  toggleSearchBar() {
    this.layoutService.layoutState.update((value) => ({
      ...value,
      searchBarActive: !value.searchBarActive,
    }));
  }

  showAvatar() {
    this.account.photo_url = '';
  }
}
